import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const SelectionSkeleton = ({count}) => {
  const skeletonItems = Array.from({ length: Number(count) || 18 }); // total number of goal cards

  return (
    <div style={{ padding: "1rem 2rem" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "1rem",
        }}
      >
        {skeletonItems.map((_, index) => (
         <div key={index} style={{ display: "flex", gap: "8px", }}>
          <div className="skeleton" style={{ width: "100%", height: "80px", marginBottom: "0px" }}></div>
        </div>
        ))}
      </div>
    </div>
  );
};
